import { Component } from "react";
import { connect } from "react-redux";
import DrawListDayItem from "./DrawListDayItem";
import Typography from "@mui/material/Typography";
import "./DrawListDay.css";

class DrawListDay extends Component {
    componentWillUnmount() {
        window.addEventListener("resize", null);
    }

    //appel au planning pour l'ouverture de la page de modification
    openModificationPanel(imputation) {
        if (!imputation.in_progress && this.props.day && !this.props.day.validation && this.props.modifiable) {
            this.props.modification(imputation);
        }
    }

    render() {
        let list = this.props.imputations.sort((a, b) => {
            return a.date_end === null
                ? b.date_end === null
                    ? a.date_start > b.date_start
                        ? 1
                        : -1
                    : 2
                : b.date_end === null
                  ? -1
                  : a.date_end > b.date_end
                    ? 1
                    : a.date_start > b.date_start
                      ? 1
                      : -1;
        });

        let planningBody;

        if (this.props.day && list.length > 0) {
            planningBody = list.map((item) => (
                <DrawListDayItem
                    modifiable={
                        !item.in_progress && this.props.day && !this.props.day.validation && this.props.modifiable
                    }
                    imputation={item}
                    openModificationPanel={this.openModificationPanel.bind(this, item)}
                    key={item.id}
                />
            ));
        } else {
            planningBody = (
                <Typography color="primary" className="no-data-centered-block">
                    {"Aucune saisie n'a été trouvée pour ce jour"}
                </Typography>
            );
        }

        return (
            <div id="container_list_planning" style={this.props.style}>
                {planningBody}
            </div>
        );
    }

    //récupération de la couleur de l'item
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        imputations: state.activeDayImputations,
    };
};
const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawListDay);
